<template>
    <div>

    <tops/>
    <div class="yszc_box">
        <!-- <img class="wenwen_de_img" src="../assets/heroes_terrains_clean_bg.png" alt=""> -->
        <h1 style="color: #323232; font-family: SimHei; position: relative; z-index: 20; margin-top: 30px; margin-bottom: 20px;">《隐私政策》</h1>
        <div class="zc_text" style="font-family: SimHei; line-height: 1.8;">
            <p style="font-weight: bold; margin-top: 20px;">隐私权政策</p>
            <p style="text-indent: 2em;">四川活力糖科技有限公司及其关联公司（[四川活力糖科技有限公司]、[我们]或[我们的]）致力于保护用户（[用户]或[您]）的隐私权。本隐私政策（以下简称[政策]）描述了我们在收集、存储、使用和管理您提供的信息以及我们在与链接到[政策]的网站或任何四川活力糖科技有限公司移动应用程序或游戏（例如iOS和安卓平台上的应用）相关的信息时所采取的方式，这些信息包括个人信息（统称为[服务]），以及您享有的隐私权。</p>
            <p style="text-indent: 2em;">请注意，本政策仅适用于四川活力糖科技有限公司司通过您使用服务收集或接收的信息。本政策不适用于第三方人士或公司的行为，也不对其网站内容、您提供的信息使用情况或其可能提供的任何产品和服务负责。链接到这些网站并不构成我们对这些人士或公司的赞助、认可或关联。</p>
            <p style="text-indent: 2em;">通过使用本服务，您确认已阅读并理解本政策以及根据本政策处理您的个人信息。</p>
            <p style="text-indent: 2em;">如果您对本政策有任何疑问或没有在这里看到您的担忧，请通过电子邮件联系我们。</p>
            <p style="font-weight: bold; margin-top: 20px;">我们从您或关于您的信息</p>
            <p style="text-indent: 2em;">四川活力糖科技有限公司收集有关您的信息如下所述。具体而言，我们使用这些信息，并在某些情况下结合这些信息来运营、定制内容、个性化服务、调整和改进我们的服务，以及根据您的偏好向您发送有关游戏、您的得分、新功能等的信息，包括用于营销和推广目的。</p>
            <p style="font-weight: bold; margin-top: 20px;">您提供的信息：</p>
            <p style="text-indent: 2em;">当您注册和/或使用我们的服务（例如，创建账户以访问我们的服务、填写应用内个人资料、与其他用户交流（如通过游戏内聊天或论坛发帖）、联系客户服务或参与任何抽奖、比赛或促销活动），我们将收集并存储您提供的所有信息。这些信息可能还包括您通过单点登录过程（如通过Facebook)提供的信息，包括账户名或账号（例如您的用户ID）、电子邮件地址或其他用于将您的在线账户与我们服务关联的标识符。</p>
            <p style="font-weight: bold; margin-top: 20px;">创建 四川活力糖科技有限公司账户。</p>
            <p style="text-indent: 2em;">在注册/注册服务的过程中，我们将收集您提供的某些信息。这些信息可能包括您的姓名、地区、电话号码或电子邮件地址。</p>
            <p style="font-weight: bold; margin-top: 20px;">你的内容。</p>
            <p style="text-indent: 2em;">我们的服务可能允许您创建、上传或分享内容，如文本、图像、音频、您的个人资料信息（如您的头像名称和外观）或其他内容，当您玩我们的游戏或以其他方式使用我们的服务时，</p>
            <p style="font-weight: bold; margin-top: 20px;">Facebook Connect、Game Center和Google+：</p>
            <p style="text-indent: 2em;">您可能能够使用登录服务（[社交登录]）如脸书连接、Apple_x0019_s游戏中心或开放身份验证提供商登录我们的服务。这些第三方社交登录平台将验证您的身份，并为您提供选择，可以与我们分享某些个人信息，例如您的姓名或电子邮件地址，以预填充我们的注册表单。像脸书连接这样的社交登录平台还允许您在该社交登录平台的个人资料页面上发布有关您在我们服务中的活动信息，以便与您的网络内其他人分享。</p>
            <p style="text-indent: 2em;">我们可能会根据相关社交登录平台的政策和条款收集并记录信息。当您将用户账户连接到社交登录平台时，我们收集的信息可能包括：(1)您的姓名，(2)您的社交登录用户识别号和/或用户名，(3)地区、城市、州和国家，(4)性别，(5)出生日期，(6)电子邮件地址，(7)个人资料图片或其网址，以及(8)您朋友在连接四川活力糖科技有限公司游戏(s)时的社交登录用户识别号。</p>
            <p style="font-weight: bold; margin-top: 20px;">邀请好友：</p>
            <p style="text-indent: 2em;">四川活力糖科技有限公司可能会向您提供邀请来自社交登录平台（如您的Facebook好友）的联系人的机会，以便这些联系人可以在四川活力糖科技有限公司的游戏里找到您和/或您可以邀请他们加入我们的游戏。此类联系信息仅用于向收件人发送邀请。</p>
            <p style="font-weight: bold; margin-top: 20px;">与客户服务的互动：</p>
            <p style="text-indent: 2em;">当您联系我们的客户服务或以其他方式与我们沟通时，我们可以收集您的电子邮件地址和您提供的任何其他个人信息。</p>
            <p style="font-weight: bold; margin-top: 20px;">论坛、抽奖、竞赛和调查：</p>
            <p style="text-indent: 2em;">我们还可能通过以下方式获取您的信息：(1)您在服务中访问和参与论坛或游戏聊天，或(2)您参与有关服务的调查。我们还可能为您提供机会通过我们的服务参加抽奖或竞赛。如果您参与，我们将要求您提供某些个人信息。参与这些抽奖和竞赛是自愿的，因此您可以选择是否披露这些信息。通常，所需的信息包括您的联系方式（如姓名和邮寄地址）以及人口统计信息（如邮政编码或同等信息）。我们使用这些信息来管理抽奖或竞赛，并通知获胜者并颁发奖品。我们可能会使用第三方服务提供商进行这些抽奖或竞赛；在这种情况下，该公司不得将您的个人信息用于任何其他目的。</p>
            <p style="font-weight: bold; margin-top: 20px;">自动收集的信息：</p>
            <p style="text-indent: 2em;">当您使用或互动我们的服务时，我们会自动收集有关您的设备和使用情况的某些信息。这可能包括您的浏览器类型和语言、IP地址、设备ID、硬件和软件信息、广告ID、游戏数据、标准服务器日志信息、您与其他用户的连接和互动、我们在服务中的购买历史以及社交媒体数据（如果您已关联您的账户并同意分享）。我们（或我们合作的第三方）使用标准跟踪技术（如日志文件、软件开发工具包（SDK）和网络信标）来实现这些目的。此外，我们或我们的合作伙伴还可能使用跟踪技术和广告ID，在我们的服务中为您提供个性化广告。有关更多详情，请参阅下文关于跟踪技术的部分[插入链接至cookie及类似技术部分]。</p>
            <p style="font-weight: bold; margin-top: 20px;">移动平台：</p>
            <p style="text-indent: 2em;">当你使用我们的任何移动游戏或应用程序时，我们或第三方合作伙伴会收集并处理有关你的某些信息，包括你的唯一设备ID（持久/非持久）、硬件类型、设备制造商、媒体访问控制（[MAC]）地址、国际移动设备身份（[IMEI]）、操作系统类型和版本（[OS]）、操作系统语言、你的唯一设备ID、时区、设备屏幕尺寸、移动设备广告ID（iOS设备称为[IDFA]，Android设备称为[Android Advertising ID]）、一般地理位置信息（基于互联网协议（[IP]）地址的城市/国家）以及你的电子邮件地址（如果你已连接到Facebook或Google+)。这些信息对我们进行故障排除非常有用，也有助于我们了解使用趋势，从而改进和个性化服务。设备标识/信息，如设备类型、硬件型号、设备制造商、设备操作系统及其语言或其他技术数据，例如屏幕尺寸，或这些数据的组合，也会被收集并用于确定设备兼容性和最佳设置。我们 也可能与我们的广告合作伙伴分享这些信息，以便向您的设备提供个性化广告的技术交付，如下文进一步描述[链接到基于兴趣的广告部分</p>
            <p style="font-weight: bold; margin-top: 20px;">用户ID：</p>
            <p style="text-indent: 2em;">当您注册使用服务时，我们会创建一个唯一的用户ID来跟踪您使用我们的服务。具体来说，这个唯一的用户ID会与您的个人资料信息一起存储，以跟踪您正在玩的四川活力糖科技有限公司的游戏。</p>
            <p style="font-weight: bold; margin-top: 20px;">游戏数据收集：</p>
            <p style="text-indent: 2em;">我们收集有关您如何使用和玩游戏的信息。例如，我们会自动收集您的游戏会话时间、游戏内互动（包括与其他玩家的互动，如适用）、可能进行的应用内购买、资源事件（如您获取或花费的游戏内虚拟货币）、用于标记您在游戏中进度或移动的进程事件（例如成就）以及安装时间戳。这些信息可能会与您的用户ID、IP地址或设备ID关联，以提供服务并改进个性化服务，或推断您的偏好、倾向、行为、能力和特长。在您同意的情况下，我们还会收集您的确切位置信息，以便将您与所在区域的其他玩家匹配。</p>
            <p style="font-weight: bold; margin-top: 20px;">移动分析：</p>
            <p style="text-indent: 2em;">像大多数移动应用一样，我们使用移动分析工具来收集有关您使用我们的移动应用和游戏的信息，以及您的设备情况和服务健康状况，以便更好地了解服务在您设备上的功能，并优化应用。这些工具可能会记录诸如您使用应用或游戏的频率、功能使用情况、游戏玩法和使用统计、应用或游戏中发生的事件、聚合使用和性能数据，以及应用或游戏的下载来源（即哪个应用商店）。</p>
            <p style="text-indent: 2em;">我们不会将存储在分析软件中的信息与移动应用程序中任何个人身份识别信息关联。</p>
            <p style="font-weight: bold; margin-top: 20px;">我们使用跟踪技术自动收集信息</p>
            <p style="font-weight: bold;">A.跟踪技术</p>
            <p class="text-content">
                我们和我们的第三方合作伙伴、附属机构或分析服务提供商使用标准跟踪技术（如网络信标、SDK、API、脚本和标签）来识别您的计算机/设备，以[记住]您访问或使用服务时的一些情况（例如您的偏好设置或用户名），并帮助我们了解您使用哪些页面和功能以及您玩的游戏。
            </p>
            <p class="text-content">
                此类信息可能与我们处理的关于您的其他个人信息相关联或结合，例如您的用户ID，用于提高我们服务的质量、根据您的兴趣定制推荐、提供和个性化我们的服务包括使我们的服务更易于使用以及用于防止欺诈、安全和认证目的。
            </p>
            <p class="text-content">
                如果您希望获得有关管理与我们服务中使用的跟踪技术相关的首选项的帮助，请参考设备制造商、操作系统开发人员或个人网络浏览器所提供的指导。
            </p>

            <!-- 基于兴趣的广告部分 -->
            <h3 class="section-title">B. 基于兴趣的广告</h3>
            <p class="text-content">
                我们的一些服务使用广告技术，通过 Cookie、清除 GIF、网络信标、跟踪像素等类似技术向您推送基于兴趣的第三方产品和服务广告。我们还可能通过我们的第三方广告合作伙伴，在其他 parties_x0019_ 网站上向您展示我们的服务。您也可能在其他服务中看到我们的游戏广告（例如在 Facebook 上）。点击这些广告并安装我们的游戏后，您将成为我们服务的用户。
            </p>
            <p class="text-content">
                当你使用我们的游戏或其它应用程序时，我们服务中集成的一些第三方工具（SDK）可能会收集并使用来自你设备的某些信息，用于广告展示和优化。这些信息包括 GAID（安卓设备上的 Google 广告 ID）或 IDFA（iOS 设备上的广告标识符）、地区（即使用特定语言的地点）、地理位置信息（需获得你的同意）以及 IP 地址。本政策不适用于我们的第三方广告合作伙伴，因为他们有自己的隐私政策，可通过下方提供的链接访问。我们无法接触或控制这些第三方。除了标识符外，这些第三方还可能收集与以下相关的信息：
            </p>
            <ul class="text-content">
                <li>广告服务和广告位置；</li>
                <li>广告可见时间；</li>
                <li>域名类型、IP 地址、广告大小；</li>
                <li>点击率（即是否点击广告）和广告响应。</li>
            </ul>
            <p class="text-content">
                他们使用这些信息（单独或与您在使用第三方网站或服务时收集到的信息结合）来：（一）实现广告的技术投放至您的设备，并验证点击率和/或安装情况；（二）为您提供更相关的广告，介绍我们服务的相关内容（例如，向您展示可能喜欢的一款游戏的优惠）；（三）启用优惠墙，让您从多种奖励广告或市场研究优惠中选择；（四）跟踪效果并衡量广告的有效性；以及（五）提高其定向和测量系统的准确性。我们建议您查阅我们的广告合作伙伴的隐私政策以获取更多信息，具体细节如下：
            </p>
            <ul class="text-content">
                <li>Tapjoy: <a href="https://www.tapjoy.com/legal/publishers/privacy-policy/" target="_blank">https://www.tapjoy.com/legal/publishers/privacy-policy/</a></li>
                <li>Tenjin: <a href="https://www.tenjin.io/privacy/" target="_blank">https://www.tenjin.io/privacy/</a></li>
                <li>Vungle: <a href="http://vungle.com/privacy/" target="_blank">http://vungle.com/privacy/</a></li>
                <li>Unity 广告：<a href="https://unity3d.com/legal/privacy-policy" target="_blank">https://unity3d.com/legal/privacy-policy</a></li>
                <li>Adcolony - <a href="https://www.adcolony.com/privacy-policy/" target="_blank"></a>https://www.adcolony.com/privacy-policy/</li>
                <li>Mopub - <a href="https://www.mopub.com/legal/privacy/" target="_blank">https://www.mopub.com/legal/privacy/</a></li>
                <li>Gameanalytics - <a href="https://gameanalytics.com/privacy" target="_blank"> https://gameanalytics.com/privacy</a></li>
            </ul>
            <p class="text-content">
                您可以通过访问网络广告倡议和数字广告联盟的网站，以及脸书广告偏好工具和隐私政策的网页，了解有关广告服务公司及其收集和使用您的信息限制选项的更多信息。同样，您也可以通过设备设置或重置苹果或安卓设备上的广告主 ID 来了解如何选择退出某些广告网络的移动应用跟踪。如需了解更多如何更改这些设置的信息，请访问：
            </p>
            <ul class="text-content">
                <li>苹果：<a href="https://support.google.com/ads/answer/2662922" target="_blank">https://support.google.com/ads/answer/2662922</a></li>
                <li>安卓：<a href="https://support.google.com/ads/answer/2662922" target="_blank">https://support.google.com/ads/answer/2662922</a></li>
                <li>Windows： <a href="http://choice.microsoft.com/en-US/opt-out" target="_blank">http://choice.microsoft.com/en-US/opt-out</a></li>
            </ul>
            <p class="text-content">
                请注意：根据本节所述调整您的偏好设置并不意味着您将不再收到广告，只是您看到的广告将与您的兴趣关联度降低。我们的广告合作伙伴仍会使用您的 device_x0019_s 广告标识符向您展示可能与您兴趣不那么相关的广告；例如，我们可能会用此标识符来限制广告展示次数（换句话说，控制您看到同一广告的次数）。您还可以按照设备制造商或操作系统开发者的说明重置与您的设备关联的广告标识符。
            </p>

            <!-- 分析技术部分 -->
            <h3 class="section-title">C. 分析技术</h3>
            <p class="text-content">
                我们使用自己的游戏服务器和第三方分析技术收集有关您如何使用我们的服务、您的计算机或设备以及我们服务的健康状况的信息。
            </p>
            <p class="text-content">
                例如，我们在服务中使用了谷歌分析，这是一项由谷歌公司（美国加利福尼亚州山景城，1600 安菲特公园大道，邮编 94043）提供的网络分析服务。谷歌分析使用 Cookie 或其他跟踪技术来帮助我们分析用户如何互动和使用我们的服务，编制关于 Services_x0019_ 活动的报告，并提供与我们的 Services_x0019_ 活动和使用相关的其他服务。谷歌使用的这些技术可能会收集您的 IP 地址、访问时间和是否是回头客等信息。我们的服务不会使用谷歌分析来收集能够识别您个人身份的信息。谷歌分析生成的信息将传输并存储在谷歌处，并受 Google_x0019_s 隐私政策约束。如需了解有关 Google_x0019_s 合作伙伴服务的更多信息，以及如何选择退出谷歌分析的跟踪，请点击这里。
            </p>
            <p class="text-content">
                对于我们在 iOS 和安卓平台上的移动应用和游戏，我们使用了 Adjust GmbH（德国柏林 Saarbr點ker 37a，10405）的服务。我们使用了 Adjust SDK（软件开发工具包），这是一项分析服务，它使我们能够获取和收集有关游戏和应用使用情况的统计数据，从而更好地了解用户如何使用我们的游戏和应用。为此，Adjust 会处理诸如 IDFA、GAID 等移动标识符。Adjust 的隐私政策在此处提供。
            </p>
            <p class="text-content">
                您的浏览器或设备可能包含[禁止跟踪]功能。由于目前尚无统一的解释方式来解读禁止跟踪信号，我们目前不会响应“禁止跟踪”信号。然而，我们提供您选择退出使用跟踪技术的能力，以发送基于兴趣的广告，如上所述。
            </p>

            <!-- 我们如何使用信息部分 -->
            <h3 class="section-title">我们如何使用信息</h3>
            <p class="text-content">
                我们使用通过我们的服务收集的信息，无论是单独还是组合使用，用于本政策中描述的目的或与我们的服务相关的披露。例如，我们可能会使用您的信息来：
            </p>
            <ul class="text-content lidian">
                <li>创建用户帐户并允许用户玩游戏和使用我们的移动应用程序；</li>
                <li>识别并建议与其他用户建立联系；</li>
                <li>了解您和您的偏好，以增强和个性化您的使用我们的服务的体验和乐趣；</li>
                <li>为您提供个性化推荐的移动应用和游戏/服务；</li>
                <li>回复客户留言和咨询，提供客户服务；</li>
                <li>提供并交付您要求的产品和服务；</li>
                <li>衡量我们服务的健康状况；</li>
                <li>设置和维护您注册的帐户；</li>
                <li>识别、修复和排除故障；</li>
                <li>激活或验证您的移动应用和游戏，并保存游戏内进度和统计数据（例如成就）；</li>
                <li>举办比赛和竞赛；</li>
                <li>通过调查或问卷调查您的意见；</li>
                <li>衡量广告效果；</li>
                <li>发送与服务有关的信息，包括确认信息、发票、技术通知、更新、安全警报以及支持和管理消息；</li>
                <li>为你提供个性化广告；</li>
                <li>通过电子邮件向您传达促销活动、奖励、即将举行的活动以及其他关于四川活力糖科技有限公司及其选定合作伙伴提供的产品和服务的新闻，遵循您的营销偏好。如果您不再希望接收我们的营销或促销信息，您可以随时通过电子邮件联系我们取消订阅。bravedefense@yeah.net 或者使用电子邮件中的退订选项；</li>
                <li>使您能够与其他用户进行通信；</li>
                <li>个性化我们服务上的内容和体验，包括根据您的偏好向您提供报告、建议和反馈；</li>
                <li>优化或改进我们的产品、服务和运营；</li>
                <li>促进软件更新，并自动更新设备上的软件；</li>
                <li>保护服务的完整性，执行我们的服务条款及其他适用条款，包括检测和防止欺诈及未经授权的行为，确保我们的系统和服务安全，防止黑客攻击、诈骗和垃圾信息，总体上确保我们的服务安全、公正，并检测、调查和预防可能违反我们政策或非法的行为；</li>
                <li>检测安全事件，防范恶意、欺骗、欺诈或非法活动，并起诉对此类活动负责的人；</li>
                <li>对服务用户进行统计、人口统计和营销分析。</li>
            </ul>
            <p class="text-content">
                我们可能会使用从您或关于您的信息来创建聚合或去标识化数据，这些数据不会具体识别您。
            </p>

            <!-- 推送通知部分 -->
            <h3 class="section-title">推送通知：</h3>
            <p class="text-content">
                在您同意并根据设备设置的情况下，我们可能会通过移动应用程序向您发送推送通知，内容包括游戏或应用更新、高分以及其他可能对您重要的服务通知。您随时可以通过在设备级别关闭这些通知来选择退出接收此类通信。
            </p>
            <h3 class="section-title">我们如何披露您的信息</h3>
            <p class="text-content">
                四川活力糖科技有限公司除经您同意或本政策另有规定外，不会分享您的个人信息。在以下情况下，我们会披露您的信息。
            </p>
            <h3 class="section-title">在您同意的情况下：</h3>
            <p class="text-content">
                经你同意，我们可以与某些第三方分享你的个人信息。
            </p>
            <h3 class="section-title">服务提供者：</h3>
            <p class="text-content">
                我们与其他公司和个人合作，根据本政策所述的目的提供服务。这些服务包括数据分析、信息技术及相关服务、支付处理、发送电子邮件和提供客户服务，以及安全欺诈检测服务。这些代理和服务提供商可能在为四川活力糖科技有限公司司提供服务时接触到您的个人信息，并有合同义务保护您个人信息的保密性和安全性。我们还要求他们仅在本政策规定的范围内使用代表我们的数据。
            </p>
            <h3 class="section-title">第三方插件：</h3>
            <p class="text-content">
                通过第三方应用程序和平台，如Facebook Connect，您可以选择在我们的网站和游戏中发布关于您活动的信息到您的个人资料页面，与网络内的其他人分享。本政策不适用于您使用任何此类第三方应用程序和服务的情况，我们不对这些第三方如何收集、使用和披露您的信息负责。我们鼓励您在连接或使用他们的应用程序和服务之前，先查阅这些第三方的隐私政策，以了解他们的信息和隐私实践。
            </p>
            <h3 class="section-title">其他用户：</h3>
            <p class="text-content">
                当你参与多人游戏时，你的游戏内资料、头像、游戏玩法和统计数据将对所有人可见。此外，如果你参与了聊天等社交功能，你公开的音频、视觉和电子信息也可能被公众获取。其他玩家也可能阅读、复制、收集或使用这些信息。请确保你的隐私设置反映了你的偏好。
            </p>
            <h3 class="section-title">保护我们或他人的披露：</h3>
            <p class="text-content">
                我们可能会根据法律规定披露您的信息，例如应传票要求，或我们认为披露信息符合法律规定；调查欺诈行为，回应政府请求，执行或应用我们的权利；保护我们或用户以及其他人的权益、财产和安全。这包括与其他公司和组织交换信息以保护欺诈行为。
            </p>
            <h3 class="section-title">合并、出售或资产转让时的披露：</h3>
            <p class="text-content">
                我们可能会在与任何合并、出售我们的资产或向另一家公司融资或收购全部或部分业务有关的情况下分享您的信息。您将通过电子邮件和/或在我们的服务上收到通知，了解所有权变更或使用您的个人信息的情况。
            </p>
            <h3 class="section-title">附属机构：</h3>
            <p class="text-content">
                我们可能会与附属公司共享个人信息。
            </p>
            <h3 class="section-title">广告合作伙伴：</h3>
            <p class="text-content">
                通过我们的服务，我们可能会允许第三方广告合作伙伴设置技术和其他跟踪工具来收集有关您使用我们的服务和您的设备的信息，如上文“基于兴趣的广告”部分进一步描述的那样。
            </p>
            <h3 class="section-title">其他重要信息</h3>
            <p class="text-content">
                政策变更
            </p>
            <p class="text-content">
                我们可能会不时更新本政策，以反映我们信息处理方式的变化。如果做出任何重大更改，我们将通过电子邮件（发送至您账户中指定的邮箱地址）或在服务页面上发布通知，在更改生效前告知您。如果我们根据适用的数据保护法需要向您提供更详细的说明或征求您的同意以进行此类更改，我们将这样做。您可以通过查看本政策顶部显示的“最后更新”日期来了解本政策最近一次更新的时间。我们鼓励您定期查看此页面，以获取关于我们隐私处理方式的最新信息。
            </p>
            <h3 class="section-title">保护措施</h3>
            <p class="text-content">
                四川活力糖科技有限公司采取合理且适当措施，保护您的信息免受未经授权的访问或第三方的丢失、滥用或篡改。尽管我们真诚地努力将收集的服务信息存储在一个不向公众开放的安全操作环境中，但我们无法保证这些信息在传输过程中或存储于系统时绝对安全。此外，虽然我们尽力确保网络和系统的完整性和安全性，但不能保证我们的安全措施能够防止第三方非法获取这些信息。我们不保证您的信息不会被第三方丢失、滥用或篡改。然而，互联网上的任何传输方式或电子存储方法都不是百分之百安全的，因此我们无法保证其绝对安全。
            </p>
            <h3 class="section-title">数据保留</h3>
            <p class="text-content">
                我们将保留您的信息，只要您的账户是有效的，或者需要提供您使用我们的服务。如果您想取消您的账户，或者要求我们不再使用您的信息来为您提供服务，请联系我们bravedefense@yeah.net尽管有上述规定，我们将根据我们的法律义务、解决纠纷和执行协议的需要保留并使用您的信息。
            </p>
            <h3 class="section-title">我们关于儿童的政策</h3>
            <p class="text-content">
                我们不会故意收集或向未满13岁（或您所在司法管辖区的成年年龄）的儿童收集个人信息，也不会允许儿童使用我们的服务。如果您是未满13岁（或您所在司法管辖区的成年年龄）的儿童，请勿向我们发送任何关于您的信息，包括姓名、地址、电话号码或电子邮件地址。任何未满13岁的人不得提供个人信息。如果您认为我们已从儿童处收集了个人信息，请使用以下联系方式联系我们。一旦我们得知已从儿童处收集到个人信息，我们将尽快在商业上可行的情况下删除这些信息。
            </p>
            <h3 class="section-title">国际转让</h3>
            <p class="text-content">
                我们可能会将收集到的关于您的信息传输给关联实体或其他第三方，无论是在境外还是从您的国家或司法管辖区向全球其他国家或司法管辖区传输。请注意，这些国家和司法管辖区可能没有与您所在司法管辖区相同的数据保护法律，我们将采取措施确保有足够的保障措施，以实现向美国及其他地区传输信息，并使用和披露有关您的信息，包括个人信息，如本政策所述。
            </p>
            <h3 class="section-title">您的隐私权选择</h3>
            <p class="text-content">
                您对提供的信息的选择
            </p>
            <p class="text-content">
                如果您不想向四川活力糖科技有限公司提供个人信息，您可以选择不提供。如果您选择不向我们提供个人信息，我们可能无法始终为您提供所需的服务。例如，如果不提供电子邮件地址，您将无法创建账户以访问和玩游戏。
            </p>
            <h3 class="section-title">您对第三方提供的信息的选择</h3>
            <p class="text-content">
                您可以通过更改您的偏好设置或直接选择退出第三方收集您的信息来控制第三方收集和分享您的信息。在向第三方披露信息之前，我们建议您查看各自隐私政策以了解更多信息。
            </p>
            <h3 class="section-title">您的营销和广告选择</h3>
            <p class="text-content">
                您可以随时选择我们如何使用您的个人信息，并随时更新您的偏好设置：
            </p>
            <p class="text-content">
                要退出个人竞赛或促销活动，或选择不接收我们的营销信息，请单击电子邮件中的退订链接或给我们发邮件bravedefense@yeah.net如果您选择不接收我们的电子邮件营销信息，请注意，我们仍可能偶尔联系您关于您的账户状态，例如通知您您的账户可能即将到期，或提供其他与服务相关的信息。
            </p>
            <p class="text-content">
                如要禁用选定的跟踪技术，以收集与广告活动效果或分析数据相关的信息，并在我们的服务中为您提供个性化广告，请参阅上面的跟踪技术部分。
            </p>
            <h3 class="section-title">访问和删除您的信息</h3>
            <p class="text-content">
                您可以通过联系bravedefense@yeah.net来停用您的 四川活力糖科技有限公司帐户或删除与您的帐户相关的电子邮件。
            </p>
            <p class="text-content">
                如果您想访问或查看我们持有的关于您的个人信息，或者出于任何原因您对我们使用您的个人信息的方式感到担忧，或者希望更正或要求删除此类个人信息，您也可以向我们发送请求bravedefense@yeah.net
            </p>
            <p class="text-content">
                如果您是加州居民或欧洲经济区（[EEA]）、英国或瑞士的用户，并且希望了解更多关于您的个人信息权利的信息，请参阅下面的相关章节。
            </p>
            <h3 class="section-title">加州居民的附加信息</h3>
            <p class="text-content">
                如果您是加州居民，以下信息也适用于您，并补充了与您使用我们的服务有关的保单中包含的信息。
            </p>

            <h3 class="section-title">我们收集的信息和信息来源</h3>
            <p class="text-content">
                我们的政策已经描述了我们收集的信息以及信息来源，请参见上述部分“我们从您或关于您的信息”。本节将这些信息按照《加州消费者隐私法》（CCPA）规定的个人信息类别进行组织。
            </p>
            <p class="text-content">
                在过去12个月中，我们收集了以下信息，用于以下目的：
            </p>
            <h3 class="section-title">标识符：</h3>
            <p class="text-content">
                这包括例如您的姓名、电子邮件地址、邮政地址、互联网协议地址、唯一个人标识符、账户用户名或屏幕名称、第三方账户名称和其他在线标识符。当您向我们提供这些信息时，或者在您与我们的服务互动过程中自动获取这些信息时，我们会获得这些信息。
            </p>
            <h3 class="section-title">互联网或其他电子网络活动信息：</h3>
            <p class="text-content">
                例如，浏览器类型、语言、设备和硬件信息、游戏玩法数据以及您与我们的服务互动的其他信息。我们在您与我们的服务互动过程中自动获取这些信息。
            </p>
            <h3 class="section-title">人口统计信息/受保护的分类特征：</h3>
            <p class="text-content">
                这包括年龄和性别等信息。当您向我们提供这些信息或在您与我们的服务互动过程中自动获得这些信息时，我们会获取这些信息。
            </p>
            <h3 class="section-title">商业信息：</h3>
            <p class="text-content">
                这包括购买或考虑的产品记录，或其他类似消费历史或倾向。这使我们能够提供技术功能，开发新产品和服务，并分析您对这些产品的使用情况。我们直接从您处获取这些信息，或在您与我们的服务互动过程中自动获得。
            </p>
            <h3 class="section-title">地理位置数据：</h3>
            <p class="text-content">
                例如，包括您的地区、邮政编码和大致地理位置。
            </p>
            <p class="text-content">
                地理位置数据，例如您的地区、邮政编码和一般地理位置信息（基于您的IP地址）。当您向我们提供这些信息或在您与我们的服务互动过程中自动获得这些信息时，我们会获取这些信息。
            </p>
            <h3 class="section-title">音频、视频及其他电子数据：</h3>
            <p class="text-content">
                这包括音频、电子、视觉或类似的信息，例如聊天以及您与我们（如客户服务目的）或其他玩家的任何互动，如照片、视频、音频、您在论坛、聊天或留言板中提交的任何信息，以及您对我们服务提供的反馈或评价。这些信息是在您向我们提供时获取的，或在您使用我们的服务过程中自动产生的。
            </p>
            <h3 class="section-title">个人资料和推断：</h3>
            <p class="text-content">
                这包括从上述任何信息中得出的推断，以创建反映偏好、特征、倾向、行为、态度、智力、能力和才能的个人资料。我们在您使用我们的服务时自动获取这些信息。
            </p>
            <p class="text-content">
                这包括从上述任何信息中推断出的资料，以创建反映偏好、特征、倾向、行为、态度、智力、能力及才能的档案。我们在您与我们的服务互动过程中自动获得这些资料。
            </p>
            <h3 class="section-title">我们如何使用和分享信息</h3>
            <p class="text-content">
                我们收集并使用个人信息用于上述“我们如何使用信息”部分所述的商业和商业目的。
            </p>
            <p class="text-content">
                四川活力糖科技有限公司不会分享您的个人信息，除非您同意或本政策另有规定。您可以在上方的[我们如何披露您的信息]部分找到更多信息。在过去12个月内，我们出于商业目的披露了以下类别的个人信息：
            </p>
            <ul class="text-content lidian">
                <li>上述所列的标识符；</li>
                <li>互联网或其他电子网络活动信息；</li>
                <li>人口统计信息/受保护分类特征；</li>
                <li>商业信息；</li>
                <li>地理位置数据；</li>
                <li>音频、视频和其他电子数据；以及</li>
                <li>个人资料和推断。</li>
            </ul>
            <p class="text-content">
                我们不会出售用户的个人信息或玩家信息。然而，我们允许某些第三方广告和分析合作伙伴通过我们的服务收集消费者信息，以提供更相关的广告、衡量广告活动效果以及检测和报告广告欺诈。合作伙伴收集的信息包括GAID（安卓设备上的Google广告ID）或IDFA（iOS设备上的广告标识符）、地区（即使用特定语言的位置）、地理位置信息（需您同意）和IP地址。如需了解更多详情或选择不使用您的数据进行广告目的，请参阅上方的“基于兴趣的广告”部分。
            </p>
            <h3 class="section-title">您的隐私权</h3>
            <p class="text-content">
                根据CCPA，加州居民拥有以下权利：
            </p>
            <ul class="text-content lidian">
                <li>知情权：您有权要求我们向您披露过去12个月收集、使用和披露的个人信息以及有关我们的数据实践的信息；</li>
                <li>删除权：您有权要求我们删除从您那里收集到的您的个人信息；</li>
                <li>不歧视权：我们不会因您行使这些权利而歧视您。</li>
                <li>选择退出销售的权利：我们不销售个人信息，所以我们没有选择退出。</li>
                <li>获得财务激励通知的权利：您有权了解任何财务激励优惠及其具体条款，有权随时选择退出这些激励措施，并且未经事先知情同意，不得纳入此类激励。目前我们不提供任何此类激励。</li>
            </ul>
            <p class="text-content">
                加州法律还允许您请求有关我们及其关联公司向第三方披露您的个人信息的某些信息，用于第三次parties_x0019_直接营销目的。我们不会将您的个人信息披露给第三方，用于其自身的直接营销目的。
            </p>
            <p class="text-content">
                由于目前还没有对如何解读“Do not Track”信号达成共识，因此我们目前不会响应“Do not Track”信号。但是，我们提供您选择不使用跟踪技术向您发送基于兴趣的广告的能力，如上所述。
            </p>
            <p class="text-content">
                要行使上述任何权利，或者如果您是授权行使CCPA项下权利的代理人，您可以发送电子邮件至bravedefense@yeah.net或通过以下提供的地址给我们发邮件。
            </p>
            <p class="text-content">
                请注意，为了保护您的信息，我们可能需要在处理您的请求之前验证您的身份。在某些情况下，我们可能需要收集额外的信息来验证您的身份，例如政府颁发的身份证。
            </p>
            <p class="text-content">
                在CCPA下，您可以自行行使这些权利，也可以指定授权代理人代您提出请求。我们可能需要您的授权代理人获得您的书面许可才能代表您提出请求，并且可能需要验证您的授权agent_x0019_s身份。如需了解有关我们的隐私政策的更多信息，您可以发送电子邮件至bravedefense@yeah.net或通过以下地址邮寄联系我们。
            </p>
            <h3 class="section-title">欧洲经济区（EEA）、英国和瑞士用户须知</h3>
            <p class="text-content">
                如果您是EEA、英国或瑞士的居民，以下信息适用于通过您使用我们的服务收集的个人数据。
            </p>
            <h3 class="section-title">数据控制器</h3>
            <p class="text-content">
                四川活力糖科技有限公司是您个人数据的数据控制者。
            </p>
            <h3 class="section-title">处理您的个人数据的法律依据</h3>
            <p class="text-content">
                我们收集、使用和分享您的个人信息，依据如下：
            </p>
            <p class="text-content">
                合同履行： 我们处理您的个人数据，以履行与您签订的合同，提供服务，包括：
            </p>
            <ul class="text-content lidian">
                <li>与我们共同管理您的账户；</li>
                <li>提供你已报名参加的比赛或促销活动；</li>
                <li>支持你购买的产品；</li>
                <li>支持游戏功能；</li>
                <li>提供客户支持。</li>
            </ul>
            <p class="text-content">
                意：我们根据您的同意处理您的个人数据。这包括，例如：
            </p>
            <ul class="text-content lidian">
                <li>关于我们的服务的新闻通讯、直接电子邮件和调查；</li>
                <li>在我们的手机游戏中投放定向广告；</li>
                <li>其他一些营销特点。</li>
            </ul>
            <p class="text-content">
                合法利益： 我们处理您的个人数据，只要我们有合法利益，并且这些利益不会凌驾于您与数据隐私相关的基本权利和自由之上。这包括，例如：
            </p>
            <ul class="text-content lidian">
                <li>为您提供所要求的客户服务或技术支持；</li>
                <li>调试和改进我们当前和未来的服务；</li>
                <li>为了向您提供专属内容，根据适用的营销偏好为您提供个性化游戏体验并联系您；</li>
                <li>在设立、行使或维护法律主张时，或在法院以司法身份行事时。</li>
            </ul>
            <h3 class="section-title">法律义务：</h3>
            <p class="text-content">
                我们还处理您的个人数据以遵守我们所受的法律义务。
            </p>
            <h3 class="section-title">国际数据传输</h3>
            <p class="text-content">
                我们收集的个人数据可能会被传输至美国或任何其他拥有设施或业务运营的国家，以及由我们或我们的附属公司、合作伙伴或服务提供商运营的国家。我们将确保将个人数据传输至第三国或国际组织时，遵守适当的保障措施。
            </p>
            <h3 class="section-title">您的隐私权</h3>
            <p class="text-content">
                您对您的个人数据拥有以下权利：
            </p>
            <h3 class="section-title">您对您的个人数据拥有以下权利：</h3>
            <p class="text-content">
                访问、更正和删除的权利：您有权查看、更正、更新或要求删除您的个人数据，具体细节见上文“访问和删除您的信息”一节。
            </p>
            <p class="text-content">
                反对权：当我们基于合法利益处理您的个人数据时，您可以基于与您具体情况相关的理由反对处理您的个人数据。例如，您可以控制我们向您营销的程度，并有权随时要求停止向您发送营销信息。您可以使用上述“您的选择”部分中描述的方法。
            </p>
            <p class="text-content">
                撤回同意的权利：如果我们根据您的同意处理您的个人数据，您有权随时撤回该同意，以进一步使用您的个人数据。您可以使用上文“您的选择”部分中描述的方法来更新您的营销偏好。
            </p>
            <p class="text-content">
                端口数据权：在某些情况下，您可以要求我们转移或传输您向我们提供的个人数据。在某些情况下，您可以要求我们转移或传输您提供给我们的个人数据。
            </p>
            <h3 class="section-title">疑问与投诉：</h3>
            <p class="text-content">
                我们希望解答您关于我们处理个人数据方式的任何疑问。然而，如果您仍有未解决的问题，也有权向相关数据保护机构投诉。您可以向居住地、工作地点或涉嫌违反数据保护法的地方提出投诉。如需更多信息，请联系您的当地数据保护机构。欧洲经济区和瑞士的数据保护机构联系方式请点击此处查看。
            </p>
            <h3 class="section-title">联系信息：</h3>
            <p class="text-content">
                如果您对本政策有任何疑问，请联系：四川活力糖科技有限公司
            </p>
        </div>
    </div>
    <Foorm/>
    </div>
</template>
<script>
   import Foorm from '@/components/fooret.vue';
    import tops from '@/components/top.vue';
    export default{
        components: {
            Foorm,
            tops
        },
        name: 'yszc',
        methods:{

        },
        watch:{
            '$store.state.EnZh'(){
                if(this.$store.state.EnZh==true){
                    this.$router.push('/en_yszc');
                }else{
                    this.$router.push('/yszc');
                }
            }
        }
    }
</script>
<style scoped lang="scss">
.yszc_box{
    width: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 70px;
    .wenwen_de_img{
        position: absolute;
        width: 100%;
        z-index: 1;
    }
    .zc_text{
        width: 60%;
        overflow-y: auto;
        // padding-top:50px;
        margin-bottom: 50px;
        // background-color: aqua;
        position: relative;
        z-index: 10;
        display: flex;
        flex-direction: column;
        color: #323232;
        padding-right: 20px;
        // padding: 20px 20px;
    }
   .zc_text::-webkit-scrollbar{
        display:none;/*隐藏滚动条*/
    } 

/* 定义滚动条样式 */
.zc_text::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background: rgba(29,29,38,.7);
}
/*定义滚动条轨道*/
.zc_text::-webkit-scrollbar-track {
		box-shadow: inset 0 0 0px rgba(255, 255, 255, 0.5);
		border-radius: 10px;
		background: rgba(29,29,38,.7);
}
/*定义滑块*/
.zc_text::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 0px rgba(255, 255, 255, 0.5);
		background-color: rgba(255, 255, 255, 0.5);
}
    .section-title {
    font-weight: bold;
    margin-top: 20px;
    font-size: 16.5px;
    }
    .text-content {
        line-height: 1.8;
        text-indent: 2em;
        a{
            color: #323232;
        }
    }
    .lidian>li::before {
        content: "•"; /* 替换为自定义符号 */
        width: 10px;
        margin-right: 8px;
    }
   
}

</style>